import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
    const navigate = useNavigate();
    const hasProcessed = useRef(false);
    const { setUser } = useAuth();
    const [error, setError] = useState("");

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = window.location.hash || "";
        const params = new URLSearchParams(hash.replace(/^#/, ""));
        const sessionId = params.get("session_id");
        if (!sessionId) {
            navigate("/login", { replace: true });
            return;
        }

        (async () => {
            try {
                const { data } = await api.post("/auth/session", { session_id: sessionId });
                setUser(data.user);
                // Clean the hash
                window.history.replaceState({}, document.title, "/calendar");
                navigate("/calendar", { replace: true, state: { user: data.user } });
            } catch (e) {
                const msg = e?.response?.data?.detail || "Authentication failed";
                setError(msg);
            }
        })();
    }, [navigate, setUser]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-[#F9F9F8] p-10">
            <div className="max-w-md w-full border border-[#E5E5E3] bg-white p-10 text-center">
                {error ? (
                    <>
                        <p className="text-xs tracking-[0.2em] uppercase text-[#888885] mb-3">Access denied</p>
                        <h2 className="font-heading text-2xl font-medium text-[#111110] mb-3" data-testid="auth-error-heading">Could not sign you in</h2>
                        <p className="text-sm text-[#666664] mb-6" data-testid="auth-error-message">{error}</p>
                        <button
                            onClick={() => navigate("/login", { replace: true })}
                            className="text-sm font-medium underline underline-offset-4 text-[#111110]"
                            data-testid="back-to-login-btn"
                        >
                            Back to sign in
                        </button>
                    </>
                ) : (
                    <>
                        <p className="text-xs tracking-[0.2em] uppercase text-[#888885] mb-3">Just a moment</p>
                        <h2 className="font-heading text-2xl font-medium text-[#111110]">Signing you in</h2>
                    </>
                )}
            </div>
        </div>
    );
}
